import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import type { PalantirBannerTheme, PalantirBannerVariant } from './banner.type';

@Component({
  selector: 'palantir-banner',
  standalone: true,
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  imports: [CommonModule],
})
export class PalantirBannerComponent {
  public theme = input<PalantirBannerTheme>('default');

  public variant = input<PalantirBannerVariant>('info');
}
